import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { isConfigFlagEnabled } from '../../../../config';
import { useAppSelector } from '../../../../redux/store';
import { DomAutoCheckButton } from './domAutoCheckButton';
import { DomAutoFoldAnyButton } from './domAutoFoldAnyButton';
export const DomAutoBetControls = () => {
    const availableAutoBetActions = useAppSelector((state) => state.poker.autoBetProperties?.availableAutoBetActions, shallowEqual);
    const autoCheckButtonBounds = useAppSelector((state) => state.gameDimensions.autoCheckButtonBounds, shallowEqual);
    const autoFoldAnyButtonBounds = useAppSelector((state) => state.gameDimensions.autoFoldAnyButtonBounds, shallowEqual);
    if (!isConfigFlagEnabled('domBetButtons')) {
        return null;
    }
    if (!availableAutoBetActions) {
        return null;
    }
    const canCheck = availableAutoBetActions.includes('check');
    const canFold = availableAutoBetActions.includes('fold');
    const canFoldAny = canCheck || canFold;
    return (_jsxs(_Fragment, { children: [canCheck && autoCheckButtonBounds && _jsx(DomAutoCheckButton, { bounds: autoCheckButtonBounds }), canFoldAny && autoFoldAnyButtonBounds && _jsx(DomAutoFoldAnyButton, { bounds: autoFoldAnyButtonBounds })] }));
};
